"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTimeDiffString = exports.getTimeDiff = exports.DateTimeFormat = void 0;
var dayjs_1 = __importDefault(require("dayjs"));
var duration_1 = __importDefault(require("dayjs/plugin/duration"));
var relativeTime_1 = __importDefault(require("dayjs/plugin/relativeTime"));
var utc_1 = __importDefault(require("dayjs/plugin/utc"));
dayjs_1.default.extend(relativeTime_1.default);
dayjs_1.default.extend(duration_1.default);
dayjs_1.default.extend(utc_1.default);
var DateTimeFormat;
(function (DateTimeFormat) {
    DateTimeFormat["full"] = "MMM D, YYYY HH:mm UTC";
    DateTimeFormat["noYear"] = "MMM D, HH:mm UTC";
    DateTimeFormat["time"] = "HH:mm UTC";
    DateTimeFormat["dayOnly"] = "MMMM D";
})(DateTimeFormat = exports.DateTimeFormat || (exports.DateTimeFormat = {}));
var getTimeDiff = function (a, b) {
    return dayjs_1.default.duration(b.diff(a));
};
exports.getTimeDiff = getTimeDiff;
var defaultDisable = {
    seconds: false,
    minutes: false,
    hours: false,
    smallerIfBig: true,
};
var getTimeDiffString = function (diff, disable) {
    if (disable === void 0) { disable = defaultDisable; }
    disable = __assign(__assign({}, defaultDisable), disable);
    var disabledHours = disable.hours || (disable.smallerIfBig && diff.asMonths() > 1);
    var disabledMinutes = disable.minutes || (disable.smallerIfBig && diff.asDays() > 1);
    var disabledSeconds = disable.seconds || (disable.smallerIfBig && diff.asMinutes() >= 1);
    var pieces = [
        diff.years() === 0 && "",
        diff.years() === 1 && "".concat(diff.years(), " year"),
        diff.years() > 1 && "".concat(diff.years(), " years"),
        diff.months() === 0 && "",
        diff.months() === 1 && "".concat(diff.months(), " month"),
        diff.months() > 1 && "".concat(diff.months(), " months"),
        diff.days() === 0 && "",
        diff.days() === 1 && "".concat(diff.days(), " day"),
        diff.days() > 1 && "".concat(diff.days(), " days"),
        !disabledHours && diff.hours() === 0 && "",
        !disabledHours && diff.hours() === 1 && "".concat(diff.hours(), " hour"),
        !disabledHours && diff.hours() > 1 && "".concat(diff.hours(), " hours"),
        !disabledMinutes && diff.asMinutes() > 1 && "".concat(diff.minutes(), " minutes"),
        !disabledSeconds && diff.asSeconds() && "".concat(diff.seconds(), " seconds"),
    ]
        .filter(Boolean)
        .join(', ');
    return pieces;
};
exports.getTimeDiffString = getTimeDiffString;
